import { RoleName } from 'consts/auth';
import { ECommerceOnboardingApplicationStatus } from 'consts/ecommerce';
import { NotificationSeverity } from 'features/general/types';
import Profile from "ui/layouts/Profile";
import { withAuthorization } from 'ui/layouts/Auth';
import ApplicationStatus, { RejectedApplicationStatus } from './ApplicationStatus';

const Onboarding = () => (
    <Profile>
        <ApplicationStatus
            slotProps={{
                alert: {
                    severity: NotificationSeverity.Info
                }
            }}
            status={[
                ECommerceOnboardingApplicationStatus.AwaitingReview,
                ECommerceOnboardingApplicationStatus.InReview
            ]}
        >
            Your account is under review, expected processing time: maximum <strong>5 days</strong>.<br />
            Our team will reach out if more details are needed.
        </ApplicationStatus>
        <ApplicationStatus
            slotProps={{
                alert: {
                    severity: NotificationSeverity.Warning
                },
                button: {
                    children: 'update application'
                }
            }}
            status={[
                ECommerceOnboardingApplicationStatus.RequestedChanges
            ]}
        >
            We have identified inaccuracies in the information submitted.<br />
            Please review the required fields and submit the changes again.
        </ApplicationStatus>
        <ApplicationStatus
            slotProps={{
                alert: {
                    severity: NotificationSeverity.Success
                },
                button: {
                    sx: {
                        display: 'none'
                    }
                }
            }}
            status={[
                ECommerceOnboardingApplicationStatus.Approved
            ]}
        >
            Your application has been approved!<br />
            We are preparing your account for launch.
        </ApplicationStatus>
        <RejectedApplicationStatus />
    </Profile>
);

export default withAuthorization(Onboarding, {
    fallback: null,
    roles: [
        RoleName.OnboardingE,
        RoleName.OnboardingO
    ]
});
